const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getAllCoverageScoreReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ALL_COVERAGE_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'ALL_COVERAGE_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'ALL_COVERAGE_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'ALL_COVERAGE_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getAllCoverageScoreReducer;


// WEBPACK FOOTER //
// ./src/reducers/getAllCoverageScore.js